<h2 matDialogTitle>{{data.title}}</h2>
<mat-dialog-content style="white-space: pre;">
  {{data.content}}
  <div *ngIf="data.htmlContent" [innerHTML]="data.htmlContent"></div>
  <div *ngIf = "data.list">
    <ul>
      <div *ngFor="let item of data.list">
        <li>{{item}}</li>
      </div>
    </ul>
  </div>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <button mat-raised-button [matDialogClose] color="primary">{{data.button || 'Okay' }}</button>
</mat-dialog-actions>
